import { usePrompt } from "hooks/HomepageBuilder/useBlocker";

const Prompt = (message: any, when: boolean) => {
	usePrompt(message, when);
	return null;
};

export default Prompt;
